@if (card_data) {
  @for (card of card_data; track card; let i = $index) {
    <div>
      @if (_currentData.currentFormFields.blocks) {
        <div class="card m-3">
          <div class="card-body">
            <dhs-form [action]="'MODIFY'" [fieldGroup]="_currentData.currentFormFields" [config]="getConfig(card)"
              [data]="card" [customButton]="_currentData.customButton" (saveFinished)="onSaveFinished($event)"
              [decorator]="_currentData.decorator" #formRef>
            </dhs-form>
          </div>
        </div>
      }
    </div>
  }
  <div class="row form-primary-actions mt-3 text-center">
    <button class="btn primary-btn pl-2 pr-2" (click)="onSaveFinished()">Return <i class="fa fa-history text-white" aria-hidden="true"></i></button>
  </div>
}